import { DSButton, DSDrawer, DSTypography } from '@eiv2/design-system';
import { NavItems } from './Sidebar';

export interface SidebarDrawerProps {
  open: boolean;
  onClose: () => void;
}

export function SidebarDrawer({ open, onClose }: SidebarDrawerProps) {
  return (
    <DSDrawer
      aria-labelledby="mobile-nav-title"
      className="flex max-h-[calc(100dvh-40px)] w-full flex-col overflow-hidden rounded-t-[24px] rounded-b-none shadow-[0_-4px_12px_rgba(0,0,0,0.12)]"
      onClose={onClose}
      open={open}
      orientation="bottom"
      overlayClassName="bg-overlay/45"
      size="fit"
    >
      <div className="flex h-6 shrink-0 items-center justify-center" aria-hidden>
        <span className="h-1 w-10 rounded-full bg-gray-3" />
      </div>

      <div className="flex shrink-0 items-center px-6 py-2">
        <DSTypography
          as="h2"
          className="text-[16px] font-semibold text-dark-3"
          id="mobile-nav-title"
        >
          Mais opções
        </DSTypography>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto pt-1 pb-2">
        <NavItems onNavigate={onClose} />
      </div>

      <div className="shrink-0 p-6">
        <DSButton className="w-full" onClick={onClose} type="button" variant="secondary">
          Fechar
        </DSButton>
      </div>
    </DSDrawer>
  );
}
